import { Component, OnInit } from '@angular/core';
import { Sections } from '../../models/sections';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItems } from '../../../../shared/Models/SelectItems';
import { FormsSectionsService } from '../../services/forms.sections.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';

@Component({
  selector: 'app-create-form',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateFormSectionComponent implements OnInit {
  source: Sections = {} as Sections;
  activityTypesOptions: SelectItems[];

  formMasterId: number;
  constructor(
    private service: FormsSectionsService,
    private router: Router,
    private diag: NbDialogRef<CreateFormSectionComponent>,
    private toast: NbToastrService
  ) {}

  ngOnInit() {}

  dropdownChange($event) {}
  save() {
    this.source.formMasterId = this.formMasterId;
    this.service.post(this.source).subscribe((res) => {
      this.toast.success('Add section successfully', 'success', { duration: 4000 });
      this.diag.close('true');
    });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
